import { useState, useEffect } from "react";

interface UseFilterParams {
  setValue: (key: string, value: any) => void;
  filterNames: string[];
}

export const useFilter = ({ setValue, filterNames }: UseFilterParams) => {
  const [filters, setFilters] = useState<Record<string, string | undefined>>(
    filterNames.reduce(
      (acc, filterName) => {
        acc[filterName] = "";
        return acc;
      },
      {} as Record<string, string | undefined>,
    ),
  );

  useEffect(() => {
    filterNames.forEach((filterName) => {
      setValue(filterName, filters[filterName] || "");
    });
  }, [filters, setValue, filterNames]);

  const setFilter = (filterName: string, value: string | undefined) => {
    setFilters((prev) => ({ ...prev, [filterName]: value }));
  };

  return { filters, setFilter };
};
